module.exports = __webpack_public_path__ + "static/img/sangdi1.cb56e937.jpg";